import React, { Component } from 'react';
import PropTypes from 'prop-types';

class FormCheckbox extends Component {
  onChange({ target: { checked } }) {
    let value;

    switch (typeof this.props.value) {
      case 'boolean':
        value = checked;
        break;
      case 'number':
        value = checked ? 1 : 0;
        break;
      case 'string':
        value = checked ? '1' : '0';
        break;
      default:
        value = false;
    }
    this.props.onChange(value);
  }

  getValue() {
    const { value } = this.props;

    switch (typeof value) {
      case 'boolean':
        return value;
      case 'number':
        return !!value;
      case 'string':
        return value === '1' || value === 'true';
      default:
        return false;
    }
  }

  render() {
    const { classStyle, id, name, style } = this.props;
    return (
      <input
        ref="checkbox"
        type="checkbox"
        id={id}
        name={name}
        className={classStyle}
        checked={this.getValue()}
        onChange={this.onChange.bind(this)}
        style={{...style}}
      />
    );
  }
}

FormCheckbox.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default FormCheckbox;
